import * as echarts from 'echarts';
import { ConsumptionFilter } from '../../stores/consumption.store';
import { TranslocoService } from '@jsverse/transloco';

// demo data taken from chartmify repo
const data: Record<ConsumptionFilter['granularity'], { xAxis: string[]; yAxis: number[] }> = {
  YEAR: {
    xAxis: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
    yAxis: [62.26, 53.55, 51.27, 38.46, 28.54, 18.86, 16.04, 6.47],
  },
  MONTH: {
    xAxis: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    yAxis: [696, 699, 481, 481, 486, 492, 493, 723, 726, 512, 517, 161],
  },
  WEEK: {
    xAxis: [
      'Mon 3 Aug',
      'Tue 4 Aug',
      'Wed 5 Aug',
      'Thu 6 Aug',
      'Fri 7 Aug',
      'Sat 8 Aug',
      'Sun 9 Aug',
    ],
    yAxis: [481, 481, 486, 492, 493, 723, 726],
  },
  DAY: {
    xAxis: [
      '00:00',
      '01:00',
      '02:00',
      '03:00',
      '04:00',
      '05:00',
      '06:00',
      '07:00',
      '08:00',
      '09:00',
      '10:00',
      '11:00',
      '12:00',
      '13:00',
      '14:00',
      '15:00',
      '16:00',
      '17:00',
      '18:00',
      '19:00',
      '20:00',
      '21:00',
      '22:00',
      '23:00',
    ],
    yAxis: [5, 5, 5, 5, 7, 11, 26, 36, 36, 25, 15, 10, 9, 9, 9, 11, 17, 29, 43, 57, 58, 44, 29, 18],
  },
};

export const getBarPlaceholderConfig = (
  dependencies: { translocoService: TranslocoService },
  options: {
    colors: {
      border: string;
      background: string;
    };
    granularity: ConsumptionFilter['granularity'];
  },
): echarts.EChartsOption => ({
  grid: {
    left: 56,
    right: 24,
    top: 40,
    bottom: 44,
  },
  xAxis: {
    type: 'category',
    data: data[options.granularity].xAxis,
    axisTick: {
      show: false,
    },
    axisLabel: {
      show: false,
    },
  },
  yAxis: {
    type: 'value',
    name: dependencies.translocoService.translate('cockpit.analysis.consumption.graph.yAxisLabel'),
    axisLabel: {
      show: false,
    },
  },
  series: [
    {
      type: 'bar',
      barMaxWidth: 40,
      emphasis: {
        disabled: true,
      },
      itemStyle: {
        color: options.colors.background,
        borderColor: options.colors.border,
        borderWidth: 1,
        borderType: 'dashed',
      },
      data: data[options.granularity].yAxis,
    },
  ],
});
